import { Button } from 'antd';
import NotFound from "./svg/404.js";
export default function ErrorPage(props) {
    return (
        <div style={{display:'flex',width:'100%',height:'100%',minHeight:'500px',alignItems:'center',justifyContent:'center',}}>
            <NotFound/>
            <div style={{marginLeft:'50px'}}>
                <div style={{fontSize:'70px',fontWeight:'600'}}>404</div>
                <div style={{color:'#666',fontSize:'16px',marginBottom:"20px"}}>抱歉,你访问的页面不存在</div>
                <Button type="primary" onClick={()=>props.history.replace('/')}>返回首页</Button>
            </div>
        </div>
    )
}